import { UNIPROMEL_DOMAIN, OPENLEGAL_DOMAIN, PRIMESALUD_DOMAIN, MENTTUM_DOMAIN } from './domains'
import { OPENSALUD360_SUBDOMAIN, INHEALTH_SUBDOMAIN } from './subdomains'

export const OPENSALUD_PLATFORM_NAME = 'opensalud'
export const OPENSALUD360_PLATFORM_NAME = 'openhealth'
export const OPENSALUD_PROFESIONALES_PLATFORM_NAME = 'Opensalud Profesionales'
export const OPENSALUD_PACIENTES_PLATFORM_NAME = 'Opensalud Pacientes'
export const PRIMESALUD_PLATFORM_NAME= 'Opensaludprime'
export const OPENLEGAL_PLATFORM_NAME = 'openlegal'
export const ABOGALITYPRO_PLATFORM_NAME = 'openlegal'
export const UNIPROMEL_PLATFORM_NAME = 'Unipromel'
export const MENTTUM_PLATFORM_NAME = 'Menttum'
export const INHEALTH_PLATFORM_NAME = 'inhealth'

export function getPlatformName() {
  const hostname = window.location.hostname;
	
  if (hostname.includes(UNIPROMEL_DOMAIN)) {
    return UNIPROMEL_PLATFORM_NAME;
  } else if (hostname.includes(MENTTUM_DOMAIN)) {
    return MENTTUM_PLATFORM_NAME;
  } else if (hostname.includes(PRIMESALUD_DOMAIN)) {
    return PRIMESALUD_PLATFORM_NAME;
  } else if (hostname.includes(OPENLEGAL_DOMAIN)) {
    return OPENLEGAL_PLATFORM_NAME;
  } else if (hostname.includes(`${OPENSALUD360_SUBDOMAIN}.`)) {
    return OPENSALUD360_PLATFORM_NAME;
  } else if (hostname.includes(INHEALTH_SUBDOMAIN)) {
    return INHEALTH_PLATFORM_NAME;
  } else {
    return OPENSALUD_PLATFORM_NAME;
  }
}

export const inOpensalud = () => getPlatformName() === OPENSALUD_PLATFORM_NAME
export const inOpensalud360 = () => getPlatformName() === OPENSALUD360_PLATFORM_NAME || getPlatformName() === MENTTUM_PLATFORM_NAME || getPlatformName() === INHEALTH_PLATFORM_NAME
export const inOpensaludProfesionales = () => getPlatformName() === OPENSALUD_PROFESIONALES_PLATFORM_NAME
export const inOpensaludPacientes = () => getPlatformName() === OPENSALUD_PACIENTES_PLATFORM_NAME
export const inPrimesalud = () => getPlatformName() === PRIMESALUD_PLATFORM_NAME
export const inOpenlegal = () => getPlatformName() === OPENLEGAL_PLATFORM_NAME
export const inAbogalitypro = () => getPlatformName() === ABOGALITYPRO_PLATFORM_NAME
export const inUnipromel = () => getPlatformName() === UNIPROMEL_PLATFORM_NAME
export const inMenttum = () => getPlatformName() === MENTTUM_PLATFORM_NAME


// WEBPACK FOOTER //
// ./src/constants/platformNames.js